<template>
  <div id="Login" class="login fullheight" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CContainer fluid class="fullheight"> 
      <CRow class="align-start align-md-center fullheight">
        <CCol cols="12" md="12" style="margin-top: 80px !important; padding: 0 0 !important;">
          <div class="login__container" :style="(showLogin ? 'max-width: 400px !important; width: 400px !important;' : 'max-width: 800px !important; width: 800px !important;') + 'margin: auto; margin-top: 20px;'">
            <div class="login__inner" :style="showLogin ? 'max-width: 400px !important;' : 'max-width: 800px !important;'">
              <div class="login__image">
                <img src="logotipo-menu.png" style="width: 200px; margin: 0 10%;" alt="Logo Oscuro">
              </div>
              <div class="login__header pt-5">
                  <h4>{{showLogin == true ? "Inicia Sesión" : "Regístrate"}}</h4>
              </div>
              <div class="login__subscribe d-flex justify-space-between align-center pb-8"><br /></div>
              <div class="login__form" v-if="showLogin == true">
                <!-- <form action="">                 -->
                  <CRow>
                    <CCol sm="12">
                      <CInput
                        v-model="email"
                        label="Correo Electrónico"
                        placeholder=""
                        autocomplete="username"
                        @input="email = email.toLowerCase()"
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="12">
                      <CInput
                        v-model="password"
                        label="Contraseña"
                        type="password"
                        autocomplete="current-password"
                        placeholder=""
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="12">
                      <CButton type="button" color="primary" style="width: 100%" @click="login">INICIAR SESIÓN</CButton>
                    </CCol>
                  </CRow>
                <!-- </form> -->
              </div>
              <div class="signup__form" v-if="showLogin == false">
                  <CRow>
                    <CCol sm="12" lg="6">
                      <CSelect
                        label="Zona: "
                        :value.sync="form.region"
                        :options="regionOptions"
                        placeholder=""
                        invalidFeedback="Este campo es requerido."
                      />
                    </CCol>
                    <CCol sm="12" lg="6">
                      <CInput
                        v-model="form.name"
                        label="Nombre"
                        placeholder=""
                        @input="form.name = form.name.toUpperCase()"
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="12" lg="6">
                      <CInput
                        type="email"
                        v-model="form.email"
                        label="Correo Electrónico"
                        placeholder=""
                        :autocomplete="false"
                        @input="form.email = form.email.toLowerCase()"
                      />
                    </CCol>
                    <CCol sm="6" lg="3">
                      <CInput
                        type="password"
                        v-model="form.password"
                        label="Contraseña"
                        placeholder=""
                        :autocomplete="false"
                      />
                    </CCol>
                    <CCol sm="6" lg="3">
                      <CInput
                        type="password"
                        v-model="form.password_confirmation"
                        label="Confirmar Contraseña"
                        placeholder=""
                        :autocomplete="false"
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="12">
                      <CSelect
                        label="Banco: "
                        :value.sync="form.bank"
                        :options="bankOptions"
                        placeholder=""
                        invalidFeedback="Este campo es requerido."
                      />
                    </CCol>
                    <CCol sm="12" v-if="showAccountField(form.bank)">
                      <CInput
                        v-model="form.account"
                        label="No. de Cuenta"
                        type="text"
                        inputmode="numeric"
                        placeholder=""
                        @input="form.account = onlyDigits(form.account)"
                        maxlength="18"
                        minlength="18"
                      />
                    </CCol>
                    <CCol sm="12">
                      <CInput
                        v-model="form.clabe"
                        label="Clabe Interbancaria"
                        type="text"
                        inputmode="numeric"
                        placeholder=""
                        @input="form.clabe = onlyDigits(form.clabe)"
                        maxlength="18"
                        minlength="18"
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="12">
                      <CButton v-if="showLogin == true" type="button" color="primary" style="width: 100%" @click="login">INICIAR SESIÓN</CButton>
                      <CButton v-if="showLogin == false" type="button" color="primary" style="width: 100%" @click="signup">REGISTRARME</CButton>
                    </CCol>
                  </CRow>
                <!-- </form> -->
              </div>
              <div class="login__actions d-flex justify-space-between py-2">
                  <div class="login__remind" style="font-size: 12px;">
                  </div>
                  <div class="login__recovery-password" style="width: 100%">
                      <a href="/#/login" class="font-weight-regular px-1" style="font-size: 12px; float: right !important;" @click="showLogin = false" v-if="showLogin == true">¡Quiero registrarme!</a>
                      <a href="/#/login" class="font-weight-regular px-1" style="font-size: 12px; float: right !important;" @click="showLogin = true" v-if="showLogin == false">¡Regresar!</a>
                  </div>
              </div>
            </div>
          </div>
        </CCol>
        <CCol cols="12" md="4" class="d-none d-md-flex login__image justify-end" style="padding-top: 280px; padding-left: 200px;"></CCol>
      </CRow>
    </CContainer>
    <DailyCodeModal ref="dailyCodeModal" @validateCode="validateCode"></DailyCodeModal>
    <loading :active="visible" :can-cancel="true"></loading>
    <CToaster placement="top-end">
      <template v-for="(toast, key) in toasts">
        <CToast :color="toast.color" v-bind="toast" :key="'toast' + key" :show="true">
          <span v-html="toast.content"></span>
        </CToast>
      </template>
    </CToaster>
  </div>
</template>
<script>
import router from '../../../router/index'
import login_ws from '../../../services/login';
import ws from '../../../services/general';
import store from '../../../store'
import axios from 'axios'
import DailyCodeModal from './DailyCodeModal.vue';
import Loading from 'vue-loading-overlay/dist/vue-loading.js';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Login',
  components: {
    Loading
  },
  data: function () {
      return {
          showLogin: true,
          email: '',
          password: '',
          name: '',
          form: {
              name: '',
              email: '',
              password: '',
              confirm_password: '',
              bank: 'BBVA',
              account: '',
              clabe: '',
              region: 'JALISCO'
          },
          submitted: false,
          regionOptions: [
            {value: 'AGUASCALIENTES', label: 'AGUASCALIENTES'}, 
            {value: 'BAJA CALIFORNIA NORTE', label: 'BAJA CALIFORNIA NORTE'}, 
            {value: 'BAJA CALIFORNIA SUR', label: 'BAJA CALIFORNIA SUR'}, 
            {value: 'CAMPECHE', label: 'CAMPECHE'}, 
            {value: 'CHIAPAS', label: 'CHIAPAS'}, 
            {value: 'CHIHUAHUA', label: 'CHIHUAHUA'}, 
            {value: 'COAHUILA', label: 'COAHUILA'}, 
            {value: 'COLIMA', label: 'COLIMA'}, 
            {value: 'DURANGO', label: 'DURANGO'}, 
            {value: 'GUANAJUATO', label: 'GUANAJUATO'}, 
            {value: 'GUERRERO', label: 'GUERRERO'}, 
            {value: 'HIDALGO', label: 'HIDALGO'}, 
            {value: 'JALISCO', label: 'JALISCO'}, 
            {value: 'MEXICO', label: 'MÉXICO'}, 
            {value: 'MICHOACAN', label: 'MICHOACÁN'}, 
            {value: 'MORELOS', label: 'MORELOS'}, 
            {value: 'NAYARIT', label: 'NAYARIT'}, 
            {value: 'NUEVO LEON', label: 'NUEVO LEÓN'}, 
            {value: 'OAXACA', label: 'OAXACA'}, 
            {value: 'PUEBLA', label: 'PUEBLA'}, 
            {value: 'QUERETARO', label: 'QUERÉTARO'}, 
            {value: 'QUINTANA ROO', label: 'QUINTANA ROO'}, 
            {value: 'SAN LUIS POTOSI', label: 'SAN LUIS POTOSÍ'}, 
            {value: 'SINALOA', label: 'SINALOA'}, 
            {value: 'SONORA', label: 'SONORA'}, 
            {value: 'TABASCO', label: 'TABASCO'}, 
            {value: 'TAMAULIPAS', label: 'TAMAULIPAS'}, 
            {value: 'TLAXCALA', label: 'TLAXCALA'}, 
            {value: 'VERACRUZ', label: 'VERACRUZ'}, 
            {value: 'YUCATAN', label: 'YUCATÁN'}, 
            {value: 'ZACATECAS', label: 'ZACATECAS'}
          ],
          bankOptions: [
            {value: 'BBVA', label: 'BANCOMER (BBVA)'}, 
            {value: 'BANAMEX', label: 'BANAMEX'}, 
            {value: 'BANORTE', label: 'BANORTE'}, 
            {value: 'SANTANDER', label: 'SANTANDER'}, 
            {value: 'HSBC', label: 'HSBC'}, 
            {value: 'SCOTIABANK', label: 'SCOTIABANK'}, 
            {value: 'BANCOPPEL', label: 'BANCOPPEL'}, 
            {value: 'BANCO AZTECA', label: 'BANCO AZTECA'}, 
            {value: 'MERCADO PAGO', label: 'MERCADO PAGO'}
          ]
      }
  },
  components: {
    DailyCodeModal
  },
  mounted: async function() {
    
  },
  computed: {
    toasts () {
      return store.state.toasts;
    },
    visible() {
      return store.state.isLoading;
    }
  },
  methods: {
    isBancomerBank: function(bank) {
      if(!bank){
        return false;
      }

      const value = bank.toString().trim().toUpperCase();

      return value == 'BANCOMER' || value == 'BBVA';
    },
    showAccountField: function(bank) {
      return this.isBancomerBank(bank);
    },
    onlyDigits: function(value) {
      if(value === null || value === undefined){
        return '';
      }

      return value.toString().replace(/\D/g, '');
    },
    signup: async function(){
      this.loading();

      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      if(this.submitted){
        await sleep(3000);
      }
      this.submitted = true;

      let params = {
        name: this.form.name,
        email: this.form.email,
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
        bank: this.form.bank,
        account: this.onlyDigits(this.form.account),
        clabe: this.onlyDigits(this.form.clabe),
        region: this.form.region,
        type: 'freelancer'
      };

      const result = await this.validateForm(params);

      if (!result.valid) {
        const errorHtml = await this.formatErrorsToList(result.errors);
        this.showToast('error', errorHtml);
        return;
      } 

      let response = await login_ws.signup(params);

      this.submitted = false;

      if(response.type == "success"){
        this.showToast('success', "Tu cuenta ha sido creada exitosamente. Por favor revisa tu correo electrónico para confirmar tu registro.");
        
        //vamos a moverlo solo para probar si funciona          
        let params = {
          email: this.form.email,
          password: this.form.password,
          device_name: "Desktop",
          type: 'freelancer'
        };

        let response = await login_ws.login(params);

        localStorage.removeItem("token");
        localStorage.removeItem("is_administrator");
        localStorage.removeItem("is_customer");
        localStorage.removeItem("customer_id");
        localStorage.removeItem("is_collaborator");
        localStorage.removeItem("is_kam");
        localStorage.removeItem("is_support");
        localStorage.removeItem("is_superadmin");

        if(response.type == "success"){
          let data = response.data;

          localStorage.setItem("token", data.access_token);

          axios.defaults.headers.common['access-token'] = data.access_token;
          axios.defaults.headers.common['api-token'] = data.access_token;

          localStorage.setItem("show_menu", data.is_administrator);

          if(data.is_freelancer !== undefined && data.is_freelancer){
            localStorage.setItem("is_freelancer", data.is_freelancer);
            localStorage.setItem("freelancer_region", data.freelancer.region);
            localStorage.setItem("show_profile_after_login", "1");
          }
          else{
            localStorage.removeItem("show_profile_after_login");
          }

          localStorage.setItem("is_administrator", data.is_administrator);
          localStorage.setItem("is_customer", data.is_customer);
          localStorage.setItem("customer_id", data.customer_id);
          localStorage.setItem("is_collaborator", data.is_collaborator);
          localStorage.setItem("is_kam", data.is_kam);
          localStorage.setItem("is_support", data.is_support);
          localStorage.setItem("is_superadmin", data.is_superadmin);

          localStorage.removeItem("date");
          localStorage.removeItem("page");
          localStorage.removeItem("branch_id");
          localStorage.removeItem("visit_id");

          localStorage.removeItem("period");
          localStorage.removeItem("period_date");
          localStorage.removeItem("last_login");

          localStorage.removeItem("kam");
          localStorage.removeItem("customers");
          localStorage.removeItem("rutas");
          localStorage.removeItem("universos");
          localStorage.removeItem("generics");

          window.location.href = "/#/home"; return;

          this.loaded();
        }
        else{
          this.showToast("error", response.message);
        }

        this.loaded();
      }
      else{
        this.showToast('error', response.message);
      }
    },
    login: async function(){
      this.loading();
      //vamos a moverlo solo para probar si funciona          
      let params = {
        email: this.email,
        password: this.password,
        device_name: navigator.userAgent,
        type: 'freelancer'
      };

      let response = await login_ws.login(params);

      localStorage.removeItem("token");
      localStorage.removeItem("is_administrator");
      localStorage.removeItem("is_customer");
      localStorage.removeItem("customer_id");
      localStorage.removeItem("is_collaborator");
      localStorage.removeItem("is_kam");
      localStorage.removeItem("is_support");
      localStorage.removeItem("is_superadmin");

      if(response.type == "success"){
        let data = response.data;

        localStorage.setItem("token", data.access_token);

        axios.defaults.headers.common['access-token'] = data.access_token;
        axios.defaults.headers.common['api-token'] = data.access_token;

        localStorage.setItem("show_menu", data.is_administrator);

        if(data.is_freelancer !== undefined && data.is_freelancer){
          localStorage.setItem("is_freelancer", data.is_freelancer);
          localStorage.setItem("freelancer_region", data.freelancer.region);
          localStorage.setItem("force_login", "0");
          localStorage.setItem("show_profile_after_login", "1");
        }
        else{
          localStorage.removeItem("show_profile_after_login");
        }

        localStorage.setItem("is_administrator", data.is_administrator);
        localStorage.setItem("is_customer", data.is_customer);
        localStorage.setItem("customer_id", data.customer_id);
        localStorage.setItem("is_collaborator", data.is_collaborator);
        localStorage.setItem("is_kam", data.is_kam);
        localStorage.setItem("is_support", data.is_support);
        localStorage.setItem("is_superadmin", data.is_superadmin);

        localStorage.removeItem("date");
        localStorage.removeItem("page");
        localStorage.removeItem("branch_id");
        localStorage.removeItem("visit_id");

        localStorage.removeItem("period");
        localStorage.removeItem("period_date");
        localStorage.removeItem("last_login");

        localStorage.removeItem("kam");
        localStorage.removeItem("customers");
        localStorage.removeItem("rutas");
        localStorage.removeItem("universos");
        localStorage.removeItem("generics");

        if(data.is_administrator){
          window.location.href = "/#/freelance-visits/available"; return;
        }
        else{
          if(data.is_customer){
            window.location.href = "/#/customer-graphs/general"; return;
          }
          else{
            if(data.is_kam || data.is_support){
              window.location.href = "/#/freelance-visits/completed"; return;
            }
            else{
              //Aqui validaremos si esta concectado desde un movil o un desktop
              const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);
              if (!isMobile) {
                await this.$refs.dailyCodeModal.show();
              }else{
                window.location.href = "/#/home"; return;
              }              
            }
          }
        }
      }
      else{
        store.commit('toast', {color: "error", message: response.message});
      }

      this.loaded();
    },
    validateForm: async function(data) {
      const fieldLabels = {
          name: 'Nombre',
          email: 'Correo electrónico',
          password: 'Contraseña',
          password_confirmation: 'Confirmación de contraseña',
          bank: 'Banco',
          account: 'No. de Cuenta',
          clabe: 'Clabe interbancaria'
      };

      const errors = {};

      const label = key => fieldLabels[key] || key;
        const requiredAccount = this.isBancomerBank(data.bank);

      // 1. Campos obligatorios
        const requiredFields = ['name', 'email', 'password', 'password_confirmation', 'bank', 'clabe'];

        if(requiredAccount){
        requiredFields.push('account');
        }

        requiredFields.forEach(key => {
        if (!data[key] || data[key].toString().trim() === '') {
          errors[key] = `${label(key)}: este campo es obligatorio`;
        }
        });

      // 2. Email válido
      if (data.email) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(data.email)) {
              errors.email = `${label('email')}: formato inválido`;
          }
      }

      // 3. Password mínimo 8 caracteres
      if (data.password && data.password.length < 8) {
          errors.password = `${label('password')}: debe tener al menos 8 caracteres`;
      }

      // 4. Confirmación de password
      if (
          data.password &&
          data.password_confirmation &&
          data.password !== data.password_confirmation
      ) {
          errors.password_confirmation = `${label('password_confirmation')}: no coincide`;
      }

      // 5. Cuenta bancaria
      if (data.clabe) {
          const clabe = this.onlyDigits(data.clabe);
          if (!/^\d{18}$/.test(clabe)) {
              errors.clabe = `${label('clabe')}: debe tener exactamente 18 dígitos numéricos`;
          }
      }

      if(requiredAccount && data.account){
        const account = this.onlyDigits(data.account);
        if(!/^\d{10}$/.test(account)){
          errors.account = `${label('account')}: debe tener exactamente 10 dígitos numéricos`;
        }
      }

        if(!requiredAccount){
        data.account = '';
        }

      return {
          valid: Object.keys(errors).length === 0,
          errors
      };
    },
    formatErrorsToList: async function(errors) {
        let html = '';

        Object.values(errors).forEach(error => {
            html += `${error}<br>`;
        });

        html += '';

        return html;
    },
    showToast(type, message){
        store.commit('toast', {color: type, message: message});
    },
    validateCode: async function(code){
      let params = {
        code: code
      };

      let response = await login_ws.validateDailyCode(params);

      if(response.type == "success" && response.data == true){        
        await this.$refs.dailyCodeModal.hide();
        window.location.href = "/#/home"; return;
      }else{
        localStorage.removeItem("token");
        localStorage.removeItem("is_administrator");
        localStorage.removeItem("is_customer");
        localStorage.removeItem("customer_id");
        localStorage.removeItem("is_collaborator");
        localStorage.removeItem("is_kam");
        alert("El codigo de acceso es incorrecto, verificalo o solicitado nuevamente.");  
        await this.$refs.dailyCodeModal.hide();
      }
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
